import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

// Глобальная обработка ошибок
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Global error:', err, info)
}

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
// router.replace('/')
